import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { interval, Subscription } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { UserRoles } from 'src/app/shared/enums/roles-enum';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { RatesAcService } from '../../services/rates-ac-service.service';
import { RatesAcCRXTService } from '../../services/ac-crxt.service';
import { TransaccionService } from 'src/app/dashboard/services/transaccion.service';
import { EstadosUsuario } from 'src/app/shared/enums/estados-usuario.enum';
import { operaComoAprobado } from 'src/app/shared/utils/estado-compliance.util';
import { SetValuesAgComponent } from 'src/app/retail/components/set-values-ag/set-values.component';
import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-main-retail',
  templateUrl: './main-retail.component.html',
  styleUrls: ['./main-retail.component.sass'],
})
export class MainRetailComponent implements OnDestroy, AfterViewInit, OnInit {
  @Input() showCopyToClipboard = false;
  subscription: Subscription = new Subscription();
  userRole: UserRoles = UserRoles.aguacate_retail_client;
  user: any;
  nombreUsuario: string = '';
  userEnum = UserRoles;
  estadoValidacion: number = -1;
  userEmail: string = '';
  currentValues: any[] = [];
  rates: any[] = [];
  pendingCount: any;
  completedCount: any;
  yesterdayDate: Date = new Date();
  todayDate: Date = new Date();
  dataCRXT: any;
  tasas: any[] = [];
  tipoTasa: string | undefined;
  hasError = false;

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private spinner: SpinnerService,
    private ratesFiatService: RatesAcService,
    private transactionService: TransaccionService,
    private agCRXTService: RatesAcCRXTService,
    private dialog: MatDialog,
    private ratesAc: RatesAcService,
    private clipboard: Clipboard,
  ) {
    this.subscription.add(
      this.store.select('auth').subscribe(({ user, userRole }: any) => {
        this.userRole = userRole;
        this.user = user;
        this.userEmail = user?.email;
        if (this.userRole === UserRoles.aguacate_retail_client) {
          this.setEstadoValidacion(user);
        }
      }),
    );
  }

  ngOnInit() {
    this.spinner.withSpinner(this.loadData());
    this.subscription.add(
      interval(30000).subscribe(() => {
        this.loadData();
      }),
    );
  }

  async loadData() {
    try {
      this.hasError = false;
      this.currentValues =
        await this.ratesFiatService.getRatesByProfile('client');
      this.yesterdayDate.setDate(this.todayDate.getDate() - 1);

      if (this.userRole === UserRoles.aguacate_retail_cashier) {
        [this.tasas, this.dataCRXT, this.completedCount, this.pendingCount] =
          await Promise.all([
            this.ratesAc.getAllRates(),
            this.getDataCRX(),
            this.transactionService.getCompletedCount(),
            this.transactionService.getPendingCount(),
          ]);
      }

      this.rates = this.currentValues;
    } catch (error) {
      this.hasError = true;
    }
  }

  setEstadoValidacion(user: any) {
    if (!this.isNotNullOrEmpty(user)) {
      this.estadoValidacion = EstadosUsuario.incompleto;
      return;
    }

    const estado = user.estadoCompliance?.estadoID;

    if ([0, 1, 2].includes(estado)) {
      this.estadoValidacion = EstadosUsuario.pendienteValidacion;
    } else if (operaComoAprobado(user)) {
      // Aprobado (3) o bloqueado (4): opera igual.
      this.estadoValidacion = EstadosUsuario.validado;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isNotNullOrEmpty(object: Object) {
    return object && Object.keys(object).length > 0;
  }

  async getDataCRX() {
    const response = await this.agCRXTService.getValuesRateCrx();
    if (response && typeof response === 'object' && 'data' in response) {
      this.tipoTasa = response.data.typeRate;
      return response.data;
    }
    return null;
  }

  async onTipoTasaChange() {
    switch (this.tipoTasa) {
      case 'CRIXTO':
      case 'CBPAY':
        await this.actualizarAutoCrixto(this.tipoTasa);
        break;
      default:
        await this.actualizarManual();
    }
  }

  async actualizarAutoCrixto(operator: string) {
    await this.spinner.withSpinner(
      (async () => {
        const response =
          await this.agCRXTService.setCalculateValuesAuto(operator);
        await this.loadData();
      })(),
    );
  }

  async actualizarManual() {
    await this.spinner.withSpinner(
      (async () => {
        const response = await this.agCRXTService.setChangeValueManual();
        await this.loadData();
      })(),
    );
  }

  async copiarTasa() {
    let message = await this.setMessage();
    this.clipboard.copy(message);
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    Toast.fire({
      icon: 'success',
      title: 'Tasas Manuales copiadas en el portapapeles',
    });
  }

  async setMessage() {
    const webRates = [this.tasas[5], this.tasas[4], this.tasas[3]];
    const whatsappRates = [this.tasas[2], this.tasas[1], this.tasas[0]];
    const formatRates = (rates: any[]) =>
      rates.map(this.calculateData).join('\n');

    return `💻 TASA WEB: pagos realizados en nuestra página web www.aguacatewallet.com
${formatRates(webRates)}

🥑 TASA VERDE: pagos reportados por WhatsApp
${formatRates(whatsappRates)}

Envía dinero de forma confiable a Venezuela con profesionales 💰💼🇻🇪 www.aguacatewallet.com`;
  }

  calculateData(data: any) {
    const rango = parseInt(data.rango.split('-')[0], 10);
    const tasa = parseFloat(data.tasa);
    const antes = (tasa * 1000).toFixed(3);
    const bs = (rango * tasa).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${data.tasa} (antes ${antes}) pagos a partir de $${rango.toLocaleString('de-DE')} pesos o ${bs} bs`;
  }

  async setRates() {
    let rate;
    switch (this.tipoTasa) {
      case 'CRIXTO':
        rate = this.dataCRXT.rateUsd;
        break;
      case 'CBPAY':
        rate = this.dataCRXT.rateUsdCBP;
        break;
      case 'MANUAL':
        rate = this.dataCRXT.rateUsdManual;
        break;
    }
    const data = {
      tasaCLP: this.dataCRXT.clp,
      porcentajeComision: this.dataCRXT.comision,
      tasaCRXT: rate,
      feeCRX: this.dataCRXT.feeCRX,
      tipoTasa: this.tipoTasa,
    };
    this.dialog
      .open(SetValuesAgComponent, { data })
      .afterClosed()
      .subscribe(async (res) => {
        if (res && res === true) {
          await this.loadData();
        }
      });
  }

  enviarDinero() {
    // Swal.fire({
    //   title: 'Enviar dinero',
    //   text: 'Selecciona el tipo de envío',
    //   showDenyButton: true,
    //   showCancelButton: false,
    //   confirmButtonColor: '#1e5a3f',
    //   denyButtonColor: '#1e5a3f',
    //   confirmButtonText: 'Uno a uno',
    //   denyButtonText: `Múltiple`,
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     this.router.navigate(['wallet/client/single']);
    //   } else if (result.isDenied) {
    //     this.router.navigate(['wallet/client/multiple']);
    //   }
    // });
    Swal.fire({
      title: 'Enviar dinero',
      text: 'Selecciona el tipo de envío',
      showCancelButton: false,
      confirmButtonColor: '#1e5a3f',
      confirmButtonText: 'Uno a uno',
    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['wallet/client/single']);
      }
    });
  }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  formatDate(date: any) {
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];

    const day = date.getDate();
    const month = months[date.getMonth()];

    return `${day} ${month}`;
  }
}
